<template>
  <div class="testimonials">
    <b-container id="testimonial-main-content">
      <b-row>
        <b-col>
          <VueSlickCarousel
            ref="VSC1"
            :asNavFor="asNavFor1"
            :autoplay="false"
            :infinite="true"
            v-bind="settings1"
            @init="onInitCarousel1"
            @afterChange="videoUpdated"
          >
            <div
              class="customerDescription col-md-12 col-sm-12"
              v-for="(customerExperience, index) in customerExperiences"
              :key="index"
            >
              <Testimonialdescrip
                :customerExperience="customerExperience"
                :key="index"
                :play="playValue"
              />
            </div>
          </VueSlickCarousel>
        </b-col>
      </b-row>
    </b-container>
    <div id="testimonial-thumbs" class="thumbnails">
      <b-container id="thumbs-container">
        <b-row class="h-100 thumbnail-carousel">
          <b-col ref="bcol">
            <VueSlickCarousel
              ref="VSC2"
              class="testi-carousel2"
              :asNavFor="asNavFor2"
              v-bind="settings2"
              @init="onInitCarousel2"
              @afterChange="onSlideChangeHandle"
            >
              <div
                class="partition"
                v-for="(customerExperience, index) in customerExperiences"
                :key="index"
              >
                <img class="image" alt="Customer Experience Image" v-lazy="require(`@/assets/img/video-thumbnails/${customerExperience.thumbnail}`)" />
              </div>
            </VueSlickCarousel>
          </b-col>
        </b-row>
        <b-row class="controls">
          <div id="prev-btn">
            <a @click="clickPrev">
              <svg
                class="bi bi-arrow-left-circle prev-next-slide"
                width="1.5em"
                height="1.5em"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  fill-rule="evenodd"
                  d="M8.354 11.354a.5.5 0 0 0 0-.708L5.707 8l2.647-2.646a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708 0z"
                />
                <path
                  fill-rule="evenodd"
                  d="M11.5 8a.5.5 0 0 0-.5-.5H6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5z"
                />
              </svg>
            </a>
          </div>
          <b-col id="progress-btn" md="3" sm="2">
            <b-progress :value="sliderPercent" height="0.25rem" variant="danger"></b-progress>
          </b-col>

          <div id="next-btn">
            <a @click="clickNext">
              <svg
                class="bi bi-arrow-right-circle prev-next-slide"
                width="1.5em"
                height="1.5em"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                />
                <path
                  fill-rule="evenodd"
                  d="M7.646 11.354a.5.5 0 0 1 0-.708L10.293 8 7.646 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0z"
                />
                <path
                  fill-rule="evenodd"
                  d="M4.5 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5z"
                />
              </svg>
            </a>
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import Videocard from "../../common/video-card";
import Testimonialdescrip from "./testimonial-description";
export default {
  name: "Testimonials",
  components: {
    VueSlickCarousel,
    // Videocard,
    Testimonialdescrip,
  },
  props: ["customerExperiences"],
  data() {
    return {
      value: 50,
      totalSlides: 0,
      currentSlideNo: 0,
      sliderPercent: 0,
      asNavFor1: null,
      asNavFor2: null,
      playValue: false,
      settings1: {
        arrows: false,
        lazyLoad: "ondemand",
        cssEase: "ease",
        autoplay: false,
        useCSS:true,
      },
      settings2: {
        arrows: false,
        lazyLoad: "ondemand",
        cssEase: "ease",
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    onInitCarousel1() {
      this.$nextTick(function () {
        // eslint-disable-next-line
        // debugger
        this.asNavFor2 = this.$refs.VSC1;
      });
    },
    onInitCarousel2() {
      // eslint-disable-next-line
      this.$nextTick(function () {
        // eslint-disable-next-line
        // debugger
        this.asNavFor1 = this.$refs.VSC2;
      });
      // debugger
    },
    onSlideChangeHandle(index) {
      this.currentSlideNo = index + 1;
      this.totalSlides = this.$props.customerExperiences.length;
      this.sliderPercent = (this.currentSlideNo / this.totalSlides) * 100;
    },
    clickNext() {
      this.$refs.VSC2.next();
    },

    clickPrev() {
      this.$refs.VSC2.prev();
    },
    videoUpdated() {
      this.playValue = false;
    },
  },
};
</script>
<style scoped>
.partition:focus {
  outline: none;
}
.customerDescription:focus {
  outline: none;
}
.image {
  width: 80%;
  height: 80%;
}

.thumbnails {
 /* background-image: url("../../../assets/background/thumbnail_bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover; */
 
  width: 100vw;
  height: 100%;
  /*margin-bottom:10%;*/
}
.color_white {
  color: var(--mainWhiteColor);
}
.testimonials {
  position: relative;
  display: flex;
  flex-flow: column;
  height: 100%;
}

.testimonial-text {
  background: var(--mainBlueColor);
}
#testimonial-title > h1 {
  font-size: 3.5rem;
  padding-bottom: 0;
  margin-bottom: 0;
  line-height: 0.7;
}
/*
.prev-next-slide {
  color: var(--mainWhiteColor);
  font-size: 1.5rem;
}
.prev-next-slide:hover {
  background: var(--mainRedColor);
  color: var(--mainlightWhiteColor);
  border-radius: 50%;
}
.controls {
  margin-left: 0 3rem;
  text-align: center;
  justify-content: center;
  padding: 1rem 0;
}
.progress {
  margin-top: 1rem;
}
*/

.prev-next-slide {
  color: var(--mainBlueColor);
  font-size: 1.5rem;
}
.prev-next-slide:hover {
  background: var(--mainRedColor);
  color: var(--mainlightWhiteColor);
  border-radius: 50%;
}
.controls {
  margin-left: 0 3rem;
  text-align: center;
  justify-content: center;
  padding-top:2rem;
  padding-bottom:1rem;
}
.progress {
  margin-top: 1rem;
}
.testimonial-head {
  font-size: 5rem;
  text-align: right;
  position: absolute;
  right: 80px;
  bottom: -37px;
}
.testimonial-image-bg {
  width: 6rem;
  height: 61px;
  position: absolute;
  bottom: 0;
  right: 0;
}
.testi-carousel2 {
  margin-top: 0rem;
}

/* Media Queries */
/* Tablet Screens */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .thumbnails {
    height: 44vh;
  }
  .testi-carousel2 {
    height: 29vh;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .thumbnails {
    height: auto;
    margin-top:2rem;
  }
  .testi-carousel2 {
    height: 15vh;
  }
  .controls{
  padding-bottom:1rem;
  padding-top:0;
}
}
/* Mobile Screen */
@media (min-width: 481px) and (max-width: 767px) {
  .testimonial-image-bg {
    width: 3rem;
    height: 43px;
    float: none;
    margin: 0;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .testimonials {
    position: relative;
    margin-top: 0;
  }
  .testimonial-head {
    text-align: right;
    font-size: 3.5rem;
    position: absolute;
    right: 40px;
    bottom: -22px;
  }
  .thumbnails {
    padding: 2rem 0;
    height: auto;
    margin-bottom: 0;
  }
  .testi-carousel2 {
    margin-top:0;
  }
  #progress-btn {
    display: none;
    margin: 0;
    padding: 0;
  }
  #prev-btn,
  #next-btn {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 0.2rem;
  }
  .slick-list{
  height:20vh;
}
.controls{
  padding-bottom:1rem;
  padding-top:2rem;
}
}
@media (max-width: 480px) {
  .testi-carousel2 {
    text-align: -webkit-center;
    /* height: auto; */
    margin-top:0;
  }
  .thumbnails {
    padding: 0;
    height: auto;
    margin-bottom: 0;
  }
  .testimonials {
    position: relative;
    margin-top: 0;
  }
  .testimonial-head {
    text-align: right;
    font-size: 3.5rem;
    position: absolute;
    right: 40px;
    bottom: -23px;
  }
  .testimonial-image-bg {
    width: 3rem;
    height: 43px;
    float: none;
    margin: 0;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  #progress-btn {
    display: none;
    margin: 0;
    padding: 0;
  }
  #prev-btn,
  #next-btn {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 0.2rem;
  }
  .slick-list{
  height:30vh!important;
}
.controls{
  padding-bottom:1rem;
  padding-top:0;
}
}
</style>
